// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_60-6";
export var headerCell = "_60-2";
export var rowWrapper = "_60-4";
export var stickyAggregationCell = "_60-a";
export var stickyAggregationRow = "_60-7";
export var stickyColumnCell = "_60-9";
export var stickyColumnHeaderCell = "_60-8";
export var table = "_60-1";
export var virtualRowWrapper = "_60-5";
export var virtualTableContainer = "_60-0";
export var white = "_60-3";